import { useMutation, useQueryClient } from '@tanstack/react-query';
import { requestItemSync } from '@/features/settings/work-integrations/api/itemSyncStatus';
import { workIntegrationsQueryKeys } from '@/features/settings/work-integrations/queryKeys';

export const useRequestItemSyncMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ itemId, integrationId }: { itemId: number; integrationId?: number }) =>
      requestItemSync({ itemId, integrationId }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: workIntegrationsQueryKeys.itemSyncStatusesPrefix(),
        }),
        queryClient.invalidateQueries({
          queryKey: workIntegrationsQueryKeys.workIntegrationItemsPrefix(),
        }),
      ]);
    },
  });
};
